<template>
    <div>
        <b-modal size="md"
                 v-model="modalShow"
                 :title="`専属${$locale.patient}削除`"
                 ok-title="削除"
                 ok-variant="yokumiru-orange"
                 cancel-title="キャンセル"
                 cancel-variant="yokumiru-gray"
                 @ok="deleteUser"
                 @cancel="close"
                 @hidden="close">
            <div v-if="user">
                <div class="modal-body">
                    <div class="jumbotron pt-3 pb-3">
                        <p>{{ $locale.patient }}番号：{{user.id}}</p>
                        <p>名前：{{user.full_name}} （ {{user.full_name_kana}} ）</p>
                        <p>年齢：{{user.age}}</p>
                    </div>
                    <p class="text-center">上記の{{ $locale.patient }}を削除します。<br>よろしいですか？</p>
                </div>
            </div>

            <div slot="modal-footer" class="w-100" :class="{ 'u-loader u-loader--sm' : inProgress }">
                <button class="btn btn-yokumiru-orange float-right" @click="deleteUser">削除</button>
                <button class="btn btn-yokumiru-gray float-right mr-2" @click="close">キャンセル</button>
            </div>
        </b-modal>
        <transition name="fade">
            <div v-show="saved" class="alert alert-success">専属{{ $locale.patient }}を削除しました。</div>
        </transition>

        <transition name="fade">
            <div v-show="failed" class="alert alert-danger">設定内容に不備があります。ご確認ください。</div>
        </transition>
    </div>
</template>

<script>
    import constants from '../../../constants';

    export default {
        name: "ExclusiveUserDeleteModal",
        data() {
            return {
                inProgress :false,
                modalShow: false,
                user: null,
                doctorId: null,
                errors: [],
                saved: false,
                failed: false,
            }
        },
        created: function () {
            bus.$on('open-modal-exclusive-user-delete', this.open);
        },

        beforeDestroy: function () {
            bus.$off('open-modal-exclusive-user-delete');
        },
        methods: {
            /**
             * モーダルを表示
             */
            open: function (data , doctorId) {
                this.modalShow = true;
                this.user = data;
                this.doctorId = doctorId;
            },

            /**
             * モーダルを閉じる
             */
            close: function() {
                this.modalShow = false;
            },

            deleteUser:function(){
                this.inProgress = true;
                axios.post(`/doctor/api/${this.doctorId}/users/exclusive/delete/${this.user.id}`)
                    .then( ({data}) => {
                        this.saved = true;
                        this.errors = [];
                        this.user = {};

                        this.modalShow = false;
                        bus.$emit( 'refresh-exclusive-users' );
                    } )
                    .catch( ({response}) => {
                        this.failed = true;

                        if ( response.data.errors ) {
                            this.errors = response.data.errors;
                        }
                    } )
                    .then( () => {
                        this.reset();
                        this.close();
                    } );
            },

            /**
             * フラグリセット
             *
             * @return {void}
             */
            reset: function() {

                const self = this;
                self.inProgress = false;
                setTimeout( () => {
                    self.saved = false;
                    self.failed = false;
                }, 3000 );
            },
        },
    }
</script>

<style scoped lang="scss">
    .alert {
        position: fixed;
        left: 50%;
        top: 20px;
        z-index: 9999;
        width: 80vw;
        transform: translate( -50%, 0 );
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .3s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>